"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";

type Props = {
  lang: string;
};

export default function ConsentSettingsButton(props: Props) {
  const T = useT();
  const { lang } = props;

  return (
    <Button
      isLink={false}
      type={ButtonType.OUTLINE}
      small={true}
      text={T(TKey.CONSENT_MANAGE)}
      onClick={() => ModalStore.getState().openConsentSettings(lang)}
    />
  );
}
